// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-34cd4038]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.pagination-wrapper[data-v-34cd4038]{display:flex;justify-content:flex-end;margin-top:20px}.editor-container[data-v-34cd4038]{padding:0 20px 20px;height:100%}.editor-container .editor__content[data-v-34cd4038]{height:calc(100% - 52px)}.editor-container .normal-input[data-v-34cd4038]{width:250px}", ""]);
// Exports
module.exports = exports;
